import { ApolloClient, from } from '@apollo/client'

import { authLink } from './authLink'
import { errorLink } from './errorLink'
import { executionTimeLink } from './executionTimeLink'
import { httpLink } from './httpLink'
import { loggerLink } from './loggerLink'
import { requestIdLink } from './requestIdLink'
import { getLoggedUser } from '../../session/sessionStorage'

// export const DEFAULT_FETCH_POLICY = 'network-only'
export const DEFAULT_FETCH_POLICY = 'cache-and-network'

export const generateClient = (name, cache) => {
  const user = getLoggedUser()
  return new ApolloClient({
    link: from([
      requestIdLink, //
      authLink, //
      loggerLink,
      errorLink,
      executionTimeLink,
      httpLink(
        user?.email === 'luciano-ribeiro.silva@prosegur.com' || user?.email === 'comercial@fortalseg.com' ? 'a' : name
      )
    ]),
    cache,
    notifyOnNetworkStatusChange: true,
    resolvers: {},
    defaultOptions: {
      notifyOnNetworkStatusChange: true,
      watchQuery: {
        fetchPolicy: DEFAULT_FETCH_POLICY,
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      },
      mutate: {
        errorPolicy: 'all',
        ignoreResults: false
      }
    }
  })
}
